export default __webpack_public_path__ + "static/media/kol.2a1b9f90.svg";